module.exports = __webpack_public_path__ + "media/images/player-icon-56ea077723f40e2c117f13b1ab51ca3b.svg";